
 <!-- Image and text -->

 <!-- Just an image -->

<!--<nav class="navbar navbar-light bg-#2d9cdb sticky-top">
  <a class="navbar-brand sticky-top" href="#" style="color: #2d9cdb;">
    Paymentor.io
  </a>
</nav>-->


    <!--<nav class="navbar sticky-top navbar-custom">
    <div class="container-fluid">
    <a class="navbar-brand" href="#">
    <img src="/docs/4.5/assets/brand/bootstrap-solid.svg" width="30" height="30" class="d-inline-block align-top" alt="" loading="lazy">
      Paymentor.io
    </a>
      </div>
  </nav>-->
<div class="container-fluid mt-3" id="hero">
<nav class="navbar navbar-light bg-#2d9cdb sticky-top">
  <a class="navbar-brand sticky-top" href="#" style="color: #2d9cdb;">
    Paymentor.io
  </a>
</nav>
    <div class="row justify-content-center">
    <div class="col-md-12" >
        <h1 class="my-2" style="font-size: 58px; font-weight: 750; font-family: 'Roboto Mono', monospace; text-transform: uppercase; line-height: 1.2; letter-spacing: 1px; word-spacing: -12px;">ALL PAYMENT API's </h1>&nbsp;
<!-- style="border: 0.01rem solid gray; height: 35%;background-image: linear-gradient(to right, rgba(25, 27, 31, 0.62), rgba(25, 27, 31, 0.52)), url(../../assets/payment_vendors.png); padding: 20px; border-radius: 4px; margin-top: 10px; margin-bottom: 20px; align-items: center; display: flex; "  -->
        <h3 style="font-family: 'Inter'; padding-top: 2.5rem; font-size: 40px;">Browse {{ allEverySources.length }}+ Payment Service Providers & API Resources ... all in one place. </h3>
        <!--<div class="counter" data-target="{{ allEverySources.length }}">0</div>-->

    </div>
    </div>
</div>


<div class="container-fluid">

  <div class="row mt-4 py-4 px-0">

    <div class="col-md-2 mt-4 py-2 px-0" id="leftbar">



        <nav class="navbar navbar-expand-lg ">

            <button class="navbar-toggler" style="color: white; font-weight: 500; float: left; margin-top: 40px;" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"><i class="fas fa-bars fa-2x"></i></span>


            </button>


          <div class="collapse navbar-collapse" id="navbarSupportedContent">


            <ul class="navbar-nav mr-auto" style="display: block;">
            <div class="input-group rounded">
                <input type="search" class="form-control rounded mt-4" placeholder="Search"  aria-label="Search"
                  aria-describedby="search-addon" />
                  <span class="input-group-text border-0" id="search-addon">
                    <i class="fas fa-search" style="cursor:pointer;" ></i>
                  </span>
            </div>

              <li class="nav-item active"><a class="nav-link" routerLink="/" style="color: white;"><i class="fas fa-home"></i> Home <span class="sr-only">(current)</span></a></li>
              <li class="nav-item" ><a class="nav-link" routerLink="/" style="color: white;"><i class="fas fa-book-open"></i> Resources</a></li>
              <li class="nav-item"><a class="nav-link" routerLink="/contact-us" style="color: white;"><i class="fas fa-envelope-open-text"></i> Contact</a></li>
              <li class="nav-item"><a class="nav-link" routerLink="/" style="color: white;"><i class="fas fa-code"></i> API's</a></li>
              <!--<li class="nav-link"><a class="" routerLink="/">Links</a></li>-->

              <!--<li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Dropdown
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" href="#">Action</a>
                  <a class="dropdown-item" href="#">Another action</a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#">Something else here</a>
                </div>
              </li>
              <li class="nav-item">
                <a class="nav-link disabled" href="#">Disabled</a>
              </li>-->
            </ul>

          </div>
        </nav>




    </div>

    <div class="col-md-6 mt-4">
      <main>
      <router-outlet></router-outlet>
      </main>

    </div>

    <div class="col-md-3 ml-4">

      <div class="mt-4">
        <a class="btn btn-success col-md-5 mr-3">Sponsors</a>

        <!-- Button trigger modal -->
        <!--<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
          Launch demo modal
        </button>-->

              <!-- Modal -->
              <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" style="color: black; font-size: 1.5rem;" id="exampleModalLabel">Add a Resource for Review </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <app-create-resource></app-create-resource>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="redirectToHomepage()">Close</button>
                      <!--<button type="button" class="btn btn-primary">Save changes</button>-->
                    </div>
                  </div>
                </div>
              </div>


        <a class="btn btn-success col-md-5 ml-3" style="color: #A6C2F7; background: #25375A;"  data-toggle="modal" data-target="#exampleModal">Add Resource</a>
      </div>
      <div class="">
        <h3 class="my-4" style="color: white; text-align: center; border: 1px solid white; border-radius: 4px; padding: 5px 10px;">Featured</h3>
        <ul class="" >
        <h3>CAREERS</h3>
            <li class="nav-link"><i class="fas fa-briefcase"></i>  <a href="https://stackoverflow.com/jobs" style="color: white;"> Looking for Jobs</a> </li>
            <li class="nav-link"><i class="fas fa-arrow-right"></i>  <a href="https://stackoverflow.com/jobs?r=true" style="color: white;"> Remote Only Jobs </a> </li>
            <li class="nav-link"><i class="fas fa-arrow-right"></i>  <a href="https://opensource.google/projects/list/featured" style="color: white;"> Open Source (Google)</a> </li>
            <li class="nav-link"><i class="fas fa-arrow-right"></i>  <a href="" style="color: white;"> Looking for Jobs</a> </li>
            <hr>
            <h3>TRENDING</h3>
            <li class="nav-link"><i class="fas fa-arrow-right"></i>  <a href="" style="color: white;"> Looking for Jobs</a> </li>
            <li class="nav-link"><i class="fas fa-arrow-right"></i>  <a href="" style="color: white;"> Looking for Jobs</a> </li>
      <hr>

        </ul>
      </div>
      <div class="this-will-be-for-twitter-api-or-smthg">
        <h3>NEWSLETTER</h3>
        <p>Subscribe your email for latest updates every other week</p>
        <form class="form inline">
          <div class="form-group">
            <input type="text" name="email" id="email" [(ngModel)]="NewsletterModel.email" class="form-control" placeholder="Enter your email" />
          </div>
          <button class="btn btn-primary btn-xs mt-2" (click)="subscribeToNewsletter()" >submit</button>

        </form>
        <div class="" *ngIf="isNewsletterSubscriptionSuccessful">
          <p class="text-success">Thank you for subscribing to our newsletter!</p>
        </div>
      </div>

    </div>





  </div>


</div>

<div class="container-fluid">

<app-footer></app-footer>
</div>



